import styles from './dashboard-gradient-form-title.module.css';
import clsx from 'clsx';
import { useMediaQuery } from '@/hooks/use-media-query';
import { Separator } from '@/components/separator';
import { useTranslation } from '@/contexts/i18n-context';
import { GradientFormTitle } from './gradient-form-title';
import { useBranding } from '@/outlets/branding-outlet';

interface DashboardGradientFormTitleProps {
  title: React.ReactNode;
  body: React.ReactNode;
  withParagraphMargins?: boolean;
  className?: string;
}

export function DashboardGradientFormTitle({
  title,
  body,
  withParagraphMargins = true,
  className,
}: DashboardGradientFormTitleProps) {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('--screen-md');
  const { humanizationTheme, welcomeMessage } = useBranding();

  const humanizationStyle = humanizationTheme
    ? ({
        '--bg-desktop-image': `url('/humanization/${humanizationTheme}/background-desktop.png')`,
        '--bg-mobile-image': `url('/humanization/${humanizationTheme}/background-mobile.png')`,
      } as React.CSSProperties)
    : undefined;

  return (
    <GradientFormTitle
      className={clsx(!!humanizationTheme && styles.withHumanization, styles.base, className)}
      withParagraphMargins={withParagraphMargins}
      style={humanizationStyle}
    >
      {welcomeMessage && isMobile && (
        <span className={styles.welcomeMessage}>{welcomeMessage}</span>
      )}
      <div className={clsx(!!humanizationTheme && styles.title)}>{title}</div>
      {isMobile && <Separator className={styles.humanizationSeparator} />}
      <div className={clsx(!!humanizationTheme && styles.body)}>{body}</div>
      {!!humanizationTheme && (
        <div className={styles.humanizationImageContainer}>
          <img
            src={`/dermatologist.png`}
            alt={t('dashboard.dermatologistAlt')}
            className={styles.humanizationImage}
          />
        </div>
      )}
    </GradientFormTitle>
  );
}
